import { Box, Typography } from '@mui/material';
import React, { useState } from 'react'
import { Button, Col, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { XLg } from 'react-bootstrap-icons';
import Popup from 'reactjs-popup';
import styles from './GWSChangeStatus.module.scss';
import DataTable from 'react-data-table-component';
import { api } from '../../../../../../../../Utils/API';
import { GOOGLE_WORKSPACE_CHANGE_STATUS_POST } from '../../../../../../../../Utils/GlobalConstants';
import Table from 'react-bootstrap/Table';
import loadingGif from "../../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import { TEXT_SECONDARY } from '../../../../../../../../Utils/ColorsConfiguration';
import { ReactivitingErrorToast, ReactivitingSuccessToast, SubscriptionSuspensionSuccessToast, SuspendSubscriptionErrorToast } from '../../../../../../../../Utils/StaticMessages/ToastMessages';
import { GWSActivationFlexibleNote, GWSSuspensionFlexibleNote, GWSSuspensionMonthlyAnnualNote, GWSUpgardeNote, ScheduleDateAllowanceNote, ScheduleDateNote, ScheduleOrderInfoNote } from '../../../../../../../../Utils/StaticMessages/NotesDisclaimers';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from 'date-fns';
 
const GWSChangeStatus = ({ subscriptionTableAPIData, setSubscriptionTableAPIData, subscriptionId, changeStatusActionPopupModalOpen, setChangeStatusActionPopupModalOpen,
    Logout, setToastSuccess, setToastError, setToastMessage, setActionCompletedRefreshSubscriptionTable, setIsActionInProgress, setIsAutoRefreshEnabled }) => {
    const [subscriptionDetailIsLoadingFlag, setSubscriptionDetailIsLoadingFlag] = useState(false) // Subscription is Loading Popup
    const [confirmSuspendFlag, setConfirmSuspendFlag] = useState(false);
    const [confirmChangeStatusLoadingFlag, setConfirmChangeStatusLoadingFlag] = useState(false);

    // schedule date
    const [selectedDate, setSelectedDate] = useState("");
    const [showNote, setShowNote] = useState(false);

    let ChangeStatusColumnNameSuspend = ["Plan", "Billing Term", "Reseller Price (Ex GST)","Renewal Price (Ex GST)*", "Quantity", "Refund"];
    let ChangeStatusColumnNameReActivate = ["Plan", "Billing Term", "Reseller Price (Ex GST)","Renewal Price (Ex GST)*", "Quantity"];
    //Stepper
    const steps = ['Select Plan', 'Select SKU', 'Add Quantity'];

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // schedule date 
    const handleKeyDown = (e) => {
        e.preventDefault();
      };
    
      const handlePaste = (e) => {
        e.preventDefault();
      };

    //post api for upgrade confirmation
    async function GwsChangeStatusPost(actionName) {
        setConfirmChangeStatusLoadingFlag(true);
        let requestBody = {
            "subscriptionId": subscriptionId,
            "planId": subscriptionTableAPIData.planId,
            "scheduledDate": selectedDate ? new Date(new Date(selectedDate).getTime() + 19800000).toISOString().split('T')[0] : "",
            "billingTerm": subscriptionTableAPIData.billingTermId,
        };
        await api.post(GOOGLE_WORKSPACE_CHANGE_STATUS_POST + actionName, requestBody, config)
            .then(resp => {
                if (resp.status = 200) {
                    setConfirmChangeStatusLoadingFlag(false);
                    setChangeStatusActionPopupModalOpen(false);
                    setSubscriptionTableAPIData(null);
                    let message
                    (actionName === "/suspend" ? message = SubscriptionSuspensionSuccessToast : message = ReactivitingSuccessToast)
                    setToastMessage(resp.data.isOrderScheduled ? resp.data.scheduleOrderMessage : message);
                    setToastSuccess(true);
                    setTimeout(() => {
                        setToastSuccess(false);
                    }, 5000);
                    setActionCompletedRefreshSubscriptionTable(true);
                    setIsActionInProgress(false);
                    setIsAutoRefreshEnabled(true);
                }
            })
            .catch(error => {
                setConfirmChangeStatusLoadingFlag(false);
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                let message;
                (actionName === "/suspend" ? message = SuspendSubscriptionErrorToast : message = ReactivitingErrorToast)
                setToastMessage(selectedDate ? error.response.data.errors : message);
                setToastError(true);
                setTimeout(() => {
                    setToastError(false);
                }, 5000);
                setIsActionInProgress(true);
                setIsAutoRefreshEnabled(false);

            })
    };

    return (
        <div>
            <Popup
                className="custom-modal custom-modal-md"
                open={confirmSuspendFlag}
                onClose={() => setConfirmSuspendFlag(false)}
                modal
                nested
            >
                {(close) => (
                    <div className="modal">
                        <div className="header p-4 py-3">
                            <h2 className="mb-0 px-3">Change Status</h2>
                            <XLg
                                size={18}
                                className="cpointer text-strong close-icon-popup-sm"
                                onClick={close}
                                color={TEXT_SECONDARY}
                            />
                        </div>
                        <Container className="p-5">
                            <p className={`pt-0 px-3 pb-5 mb-0 ${styles['change-status-gws-confirmation-line']}`}>
                                {subscriptionTableAPIData && subscriptionTableAPIData.status === "ACTIVE" ? <strong>Are you sure you want to Suspend Subscription?</strong> : <strong>Are you sure you want to Re - Activate Subscription?</strong>}
                            </p>
                            <div className="actions">
                                <div className="d-flex justify-content-center pb-3 pt-2">
                                    <Button
                                        className="btn btn-lg mx-3 btn-border-light"
                                        variant="light"
                                        onClick={() => {
                                            close();
                                        }}
                                    >
                                        No
                                    </Button>
                                    <Button
                                        className="btn btn-md"
                                        onClick={() => {
                                            { subscriptionTableAPIData && subscriptionTableAPIData.status === "ACTIVE" ? GwsChangeStatusPost("/suspend") : GwsChangeStatusPost("/activate") };
                                            close();
                                        }}
                                    >
                                        Yes
                                    </Button>
                                </div>
                            </div>
                        </Container>
                    </div>
                )}
            </Popup>
            <Popup
                className="custom-modal custom-modal-xl"
                open={changeStatusActionPopupModalOpen}
                onClose={() => {setChangeStatusActionPopupModalOpen(false);setSubscriptionTableAPIData(null);setSelectedDate("");setShowNote(false);}}
                modal
                closeOnDocumentClick={!confirmChangeStatusLoadingFlag}
                nested
            >
                {(close) => (
                    <div className="modal">
                        {!subscriptionDetailIsLoadingFlag &&
                            <>
                                <div className="header">
                                    <h2>Change Status</h2>
                                    <XLg
                                        size={18}
                                        className="cpointer text-strong"
                                        onClick={() => { if (!confirmChangeStatusLoadingFlag) close() }}
                                        color={TEXT_SECONDARY}
                                    />
                                </div>
                                <Container  className={` action-modal-height pt-0 pb-3 ${styles['modal-width']}`}>
                                    <Box sx={{ width: '100%' }}>
                                        <React.Fragment>
                                            <Typography sx={{ mt: 2, mb: 1 }}>
                                                {subscriptionTableAPIData && (subscriptionTableAPIData.status === "ACTIVE" ? <p className='text-strong'>Suspend Subscription</p> : <p className='text-strong'>Re - Activate Subscription</p>)}
                                                <div className={`table-responsive ${styles['gws-downgrade-core']}`}>
                                                    {subscriptionTableAPIData &&
                                                    <>
                                                        <Table className={`${styles['gws-change-status-core-table']}`} responsive="md">
                                                            <thead>
                                                                <tr>
                                                                    {subscriptionTableAPIData.status === "ACTIVE" ? ChangeStatusColumnNameSuspend.map(th => {
                                                                        return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity" || th==="Renewal Price (Ex GST)*") ? "text-right" : ""}>{
                                                                            th === "Billing Term" ? <>{th}
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={<Tooltip className={`${styles['gws-tooltip']}`}>Billing Term (Commitment Term)</Tooltip>}

                                                                                >
                                                                                    <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                                                </OverlayTrigger></> : th}</th>)
                                                                    }) :
                                                                        ChangeStatusColumnNameReActivate.map(th => {
                                                                            return (<th className={(th === "Reseller Price (Ex GST)" || th === "Quantity" || th==="Renewal Price (Ex GST)*") ? "text-right" : ""}>{
                                                                                th === "Billing Term" ? <>{th}
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip className={`${styles['gws-tooltip']}`}>Billing Term (Commitment Term)</Tooltip>}

                                                                                    >
                                                                                        <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                                                    </OverlayTrigger></> : th}</th>)
                                                                        })
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    <tr>
                                                                        <td>{subscriptionTableAPIData.planName}</td>
                                                                        <td>{subscriptionTableAPIData.billingTerm}</td>
                                                                        <td className={`text-right ${styles['reseller-price']}`}>${subscriptionTableAPIData.price}</td>
                                                                        <td className={`text-right ${styles['reseller-price']}`}>${subscriptionTableAPIData.rrpExclusiveTax}</td>
                                                                        <td className='text-right'>{subscriptionTableAPIData.quantity}</td>
                                                                        {subscriptionTableAPIData.status === "ACTIVE" && <td>{subscriptionTableAPIData.refund}</td>}
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                            {!subscriptionTableAPIData?.isOrderScheduled && <div className='mt-4 mb-2'>
                                                        <Form.Label className="w-auto" htmlFor="scheduleDate">Schedule Date</Form.Label>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip className='tooltip-upgrade-destination'>
                                                                {ScheduleOrderInfoNote}
                                                            </Tooltip>}
                                                        >
                                                            <span className="notes-confirmation infoIcon-support-table"></span>
                                                        </OverlayTrigger><span className='mr-3'>:</span>
                                                                <DatePicker
                                                                    showIcon
                                                                    selected={selectedDate}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    onChange={(date) => {
                                                                        setSelectedDate(date);
                                                                        setShowNote(!!date); // Show note if a date is selected
                                                                    }}
                                                                    minDate={addDays(new Date(), 1)}
                                                                    maxDate={addDays(new Date(), 30)}
                                                                    placeholderText="DD/MM/YYYY"
                                                                    toggleCalendarOnIconClick
                                                                    isClearable={true}
                                                                    onKeyDown={handleKeyDown}
                                                                    onPaste={handlePaste}
                                                                />
                                                            </div>}
                                                            </>
                                                    }
               
                                                    {!subscriptionTableAPIData &&
                                                        <div className={styles["loading-plans"]}><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading . . .</p></div>
                                                    }
                                                </div>
                                            </Typography>
                                            {/* buttons for downgrade */}
                                            <div className='text-right pt-1 pb-4'>
                                                <React.Fragment>
                                                    <Row>
                                                        <Col md={9}>
                                                        {subscriptionTableAPIData && <>
                                                            <ul className={`px-3 ${styles['note-p']}`}>
                                                                <strong>Note* :</strong>
                                                                <li className='mt-1 mb-0'> {GWSUpgardeNote}</li>
                                                                {subscriptionTableAPIData?.isOrderScheduled && <li className='mt-1 mb-0'>{ScheduleDateAllowanceNote}</li>}
                                                                {showNote && (
                                                                    <>
                                                                        {subscriptionTableAPIData.status === "ACTIVE" ? (
                                                                            <>
                                                                                {subscriptionTableAPIData.billingTermId === "FlexiblePlan" ? (
                                                                                    <li className='mt-1 mb-0'>{GWSSuspensionFlexibleNote}</li>
                                                                                ) : (
                                                                                    <li className='mt-1 mb-0'>{GWSSuspensionMonthlyAnnualNote}</li>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <li className='mt-1 mb-0'>{GWSActivationFlexibleNote}</li>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </ul>
                                                        </>}
                                                        </Col>
                                                        <Col className='mt-4'>
                                                        {!confirmChangeStatusLoadingFlag && subscriptionTableAPIData && <Button
                                                        className={`${!subscriptionTableAPIData?.isOrderScheduled ? "" : "my-3"}`}
                                                        onClick={() => setConfirmSuspendFlag(true)}
                                                    >
                                                        {subscriptionTableAPIData.status === "ACTIVE" ? "Suspend Subscription" : "Re-Activate Subscription"}
                                                    </Button>}
                                                    {confirmChangeStatusLoadingFlag && subscriptionTableAPIData && <Button
                                                        disabled
                                                        className={`ml-3 btn-border-light w-md-auto col-xs-12 ${!subscriptionTableAPIData?.isOrderScheduled ? "" : "my-3"}`}
                                                        variant="light"
                                                    >
                                                        Processing . . .
                                                    </Button>}
                                                        </Col>
                                                    </Row>
                                                    
                                                </React.Fragment>
                                            </div>
                                        </React.Fragment>

                                    </Box>
                                </Container>
                            </>
                        }
                    </div>
                )}
            </Popup>
        </div>
    )
}

export default GWSChangeStatus
